import DefaultDelegationRateVehicle from "./delegationRateVehicle";
import vue from "../../main";

export default class CustomDelegationRateVehicle extends DefaultDelegationRateVehicle {
  constructor(groupId) {
    super();
    this.groupId = groupId;
  }

  rules() {
    return {
      delegation_vehicle_under_900_rate: [],
      delegation_vehicle_above_900_rate: [],
      delegation_vehicle_moped_rate: [],
      delegation_vehicle_motorcycle_rate: []
    };
  }

  load(strict = false) {
    vue.axios.get("settings/delegation-rate/get-delegation-vehicle-rate?groupId=" + this.groupId + "&strict=" + strict).then(resp => {
      this.delegation_vehicle_motorcycle_rate =
        resp.data.delegation_vehicle_motorcycle_rate != null ? resp.data.delegation_vehicle_motorcycle_rate.toString() : null;
      this.delegation_vehicle_moped_rate = resp.data.delegation_vehicle_moped_rate != null ? resp.data.delegation_vehicle_moped_rate.toString() : null;
      this.delegation_vehicle_above_900_rate =
        resp.data.delegation_vehicle_above_900_rate != null ? resp.data.delegation_vehicle_above_900_rate.toString() : null;
      this.delegation_vehicle_under_900_rate =
        resp.data.delegation_vehicle_under_900_rate != null ? resp.data.delegation_vehicle_under_900_rate.toString() : null;
    });
  }

  save() {
    return new Promise((resolve, reject) => {
      vue.axios
        .post("settings/delegation-rate/save-delegation-vehicle-rate", this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }
}
